import { BlogCard } from './Tabs';

import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import { getDeviceType } from '@utils/functions/getDeviceType';

const RelatedPosts = ({ blogData, relatedBlogs, deviceType }) => {
  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 3.5,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 2.5,
    },
    tablet: {
      breakpoint: { max: 1024, min: 679 },
      items: 1.5,
    },
    mobile: {
      breakpoint: { max: 678, min: 0 },
      items: 1,
    },
  };
  if (!relatedBlogs?.length) return null;
  return (
    <>
      <h2 className="my-8 mt-32 ml-8 text-[36px] lg:ml-0">Related Posts</h2>
      <div className="">
        <Carousel
          swipeable={true}
          draggable={true}
          responsive={responsive}
          arrows={true}
          ssr={true} // means to render carousel on server-side.
          // infinite={true}
          partialVisible={true}
          itemClass="slider-crousel"
          keyBoardControl={true}
          containerClass="carousel-container"
          removeArrowOnDeviceType={['tablet', 'mobile']}
          deviceType={getDeviceType()}
          dotListClass="owl-dots"
          showDots={true}
        >
          {/* {blogData.category.data.attributes.articles.data
                .filter((item) => item.attributes.slug !== blogData.slug)
                ?.map((item, index) => (
                  <BlogCard key={index} {...item} />
                ))} */}
          {relatedBlogs.map((item) => (
            <BlogCard key={item.id} {...item} />
          ))}
        </Carousel>
      </div>
    </>
  );
};

export default RelatedPosts;
